/**
 * Triggers a browser download of a base64-encoded file via a Blob object URL.
 * Revokes the object URL after the click so repeated exports don't leak memory.
 */
export function DownloadBase64File(base64: string, fileName: string, mimeType = 'application/pdf'): void {
    const bytes = Uint8Array.from(atob(base64), ch => ch.charCodeAt(0));
    const blob = new Blob([bytes], { type: mimeType });
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = fileName;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    URL.revokeObjectURL(url);
}
